module.exports = __webpack_public_path__ + "img/hub_color.b7e46cf0.svg";